import { useEffect, useState } from "react";
import { useUserInfor } from "../../../../../../../Context/User";
import {
    AtualizarConfigGeralController,
    ListaFormularioPorModuloController,
    VincularFormularioModuloController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import UnForm from "../../../../../../Form";
import { IConfigGeral_URA } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import OrSpinner from "../../../../../../Utils/OrSpinner";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
// import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";
import { ListarFormulariosController } from "../../../../../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { ACESSOS } from "../../../../../../../Routes/Acessos";
import { ListarEmailContaController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import { ListarTipoAgendamentoController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/TipoAgendamento/TipoAgendamentoController";

interface IAssistenciaConfigProps {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function AssistenciaConfig(props: IAssistenciaConfigProps) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigAssistenciaTecnicaDTO;
    const { ConfigAssistenciaTecnicaDTO } = useUserInfor().Config;
    let configUra = Config.ConfigsUraDTO;
    const [findCategoria, setFindCategoria] = useState<
        IConfigGeral_URA | undefined
    >();
    const [loading, setLoading] = useState(true);

    // const [emailDestinatario, setEmailDestinatario] = useState<
    //     Array<string> | undefined
    // >([]);
    // const customStyles = {
    //     control: (base: any) => ({
    //         ...base,
    //         boxShadow: "none",
    //     }),
    // };

    // const { value: lstContatos, ...ListarContatos } = useAsyncEffect(
    //     () => ListarContatosController(props.ID_CONTA, props.ID_CASO),
    //     [props.ID_CONTA]
    // );

    // const options = lstContatos?.map((contato) => ({
    //     label: `${contato.DS_EMAIL ? contato.DS_NOME : ""} ${
    //         contato.DS_EMAIL ? `<${contato.DS_EMAIL}>` : ""
    //     }`,
    //     value: contato.DS_EMAIL ?? "",
    // }));

    // const idModuloAssistenciaTecnica = props.lstConfigModulo?.find(
    //     (lst) => lst.ID_MODULO === 1
    // );

    // const { value: getConfigModulo } = useAsyncEffect(async () => {
    //     if (idModuloAssistenciaTecnica) {
    //         return GetConfigModuloController(
    //             idModuloAssistenciaTecnica.ID_MODULO
    //         );
    //     }
    // }, [idModuloAssistenciaTecnica]);

    const { value: lstFormularioPorModulo, execute: ListaFormularioPorModulo } =
        useAsyncEffect(
            () =>
                ListaFormularioPorModuloController(
                    ACESSOS.ASSISTENCIA.ID_MODULO
                ),
            []
        );

    const {
        execute: VincularFormularioModulo,
        loading: VincularFormularioModuloLoading,
    } = useAsyncCallback(VincularFormularioModuloController);

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigAssistenciaTecnicaDTO: {
                ...config,
            },
            ConfigsUraDTO: configUra,
        }).then(() => {
            updateConfig();
        });
    }

    useEffect(() => {
        if (loading) {
            const findCategoriaAtendimento = configUra?.find((config) => {
                return config.ID_TIPO_CASO === 2;
            });
            setFindCategoria(findCategoriaAtendimento);
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configUra]);

    const handleSubmit = (formValue: any) => {
        configUra = formValue.ID_CATEGORIA_ATENDIMENTO_URA
            ? [
                  {
                      ID_CATEGORIA_ATENDIMENTO:
                          formValue.ID_CATEGORIA_ATENDIMENTO_URA,
                      ID_TIPO_CASO: 1,
                  },
              ]
            : configUra;
        update();
    };

    const handleEmailSubmit = (formValue: any) => {
        config.DS_EMAIL_ENVIO_ASSIS_TECNICA = formValue.ID_REMETENTE
            ? formValue.ID_REMETENTE
            : null;
        update();
    };

    const { execute: ListarTipoAgendamento } = useAsyncCallback(
        () => ListarTipoAgendamentoController(),
        []
    );

    const handleTipoCompromisso = (formValue: any) => {
        config.ID_COMPROMISSO_AGENDAMENTO_VISTORIA_INICIAL =
            formValue.ID_COMPROMISSO_AGENDAMENTO_VISTORIA_INICIAL
                ? formValue.ID_COMPROMISSO_AGENDAMENTO_VISTORIA_INICIAL
                : 0;
        config.ID_COMPROMISSO_AGENDAR_MANUTENCAO =
            formValue.ID_COMPROMISSO_AGENDAR_MANUTENCAO
                ? formValue.ID_COMPROMISSO_AGENDAR_MANUTENCAO
                : 0;
        update();
    };

    const handleFormularioSubmit = (formValue: any) => {
        if (formValue.ID_FORMULARIO) {
            console.log("Formulário selecionado", formValue.ID_FORMULARIO);
            VincularFormularioModulo(
                ACESSOS.ASSISTENCIA.ID_MODULO,
                formValue.ID_FORMULARIO
            ).then(() => {
                ListaFormularioPorModulo();
                update();
            });
        }
    };

    return (
        <OrSpinner loading={loading} loadingColor="primary">
            <div className="col-12 mb-4">
                <h4>Enviar Notificação por E-mail</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir que seja enviado um e-mail ao avançar etapa
                        para o cliente?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config.FL_ENVIAR_EMAIL_CLIENTE_AT}
                                    onChange={() => {
                                        config.FL_ENVIAR_EMAIL_CLIENTE_AT =
                                            !config.FL_ENVIAR_EMAIL_CLIENTE_AT;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Enviar Notificação por E-mail por Grupo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir que seja enviado um e-mail ao avançar etapa por
                        grupo?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config.FL_NOTIFICA_GRUPO}
                                    onChange={() => {
                                        config.FL_NOTIFICA_GRUPO =
                                            !config.FL_NOTIFICA_GRUPO;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {ConfigAssistenciaTecnicaDTO.FL_PERMITIR_MANUTENCAO_CONCLUIDA ===
            true ? (
                <>
                    <div className="col-12 mb-4">
                        <h4>Custos</h4>
                        <div className="d-flex flex-column">
                            <label className="col-12 col-form-label px-0">
                                Permitir Custear o cliente
                            </label>
                            <div className="col-12">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO
                                            }
                                            onChange={() => {
                                                config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO =
                                                    !config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO;
                                                update();
                                            }}
                                            name="select"
                                        />

                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mb-4">
                        <h4>Reparo</h4>
                        <div className="d-flex flex-column">
                            <label className="col-12 col-form-label px-0">
                                Permitir que o reparo seja concluído e custeado?
                            </label>
                            <div className="col-12">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                config.FL_PERMITIR_MANUTENCAO_CONCLUIDA
                                            }
                                            onChange={() => {
                                                config.FL_PERMITIR_MANUTENCAO_CONCLUIDA =
                                                    !config.FL_PERMITIR_MANUTENCAO_CONCLUIDA;
                                                update();
                                            }}
                                            name="select"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="col-12 mb-4">
                    <h4>Reparo</h4>
                    <div className="d-flex flex-column">
                        <label className="col-12 col-form-label px-0">
                            Permitir que o Reparo seja concluído e custeado?
                        </label>
                        <div className="col-12">
                            <span className="switch switch-outline switch-icon switch-success">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={
                                            config.FL_PERMITIR_MANUTENCAO_CONCLUIDA
                                        }
                                        onChange={() => {
                                            config.FL_PERMITIR_MANUTENCAO_CONCLUIDA =
                                                !config.FL_PERMITIR_MANUTENCAO_CONCLUIDA;
                                            update();
                                        }}
                                        name="select"
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="col-12 mb-4">
                <h4>Finalização do Reparo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir a finalização do reparo sem a necessidade de
                        informar o motivo.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_FINALIZAR_REPARO_SEM_MODAL
                                    }
                                    onChange={() => {
                                        config.FL_FINALIZAR_REPARO_SEM_MODAL =
                                            !config.FL_FINALIZAR_REPARO_SEM_MODAL;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {/* <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div> */}

            <div className="col-12 mb-4">
                <h4>Finalizar o caso sem considerar o SLA</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja encerrar o caso sem aplicar a contagem do SLA?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_PARALISAR_CASO_AT_SEM_SLA
                                    }
                                    onChange={() => {
                                        config.FL_PARALISAR_CASO_AT_SEM_SLA =
                                            !config.FL_PARALISAR_CASO_AT_SEM_SLA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {/*   <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        texto aq
                    </label>
                   <div className="col-6">
                        <label>Email Destinatário:</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={(e) => {
                                setEmailDestinatario(
                                    e.map((value) => value?.value)
                                );
                            }}
                            formatCreateLabel={(value) =>
                                `Clique para selecionar: ${value}`
                            }
                            styles={customStyles}
                            placeholder={"Digite o email"}
                            options={{
                                
                            }}
                            // defaultValue={
                            //     lstContatos?.filter(
                            //         (c) => c.FL_PROPONENTE === true
                            //     )[0]?.DS_EMAIL !== ""
                            //         ? defaultValue()
                            //         : undefined
                            // }
                            className="Select-menu-outer"
                        />
                    </div> 
                    <div className="col-6 ml-2">
                        <button className="btn btn-success">Salvar</button>
                    </div>
                </div>*/}

            <UnForm handleSubmit={handleTipoCompromisso}>
                <h4 className="pt-2">Tipo de compromisso</h4>
                <div className="d-flex flex-column col-12 col-md-6">
                    <label className="pt-2">
                        Informe o tipo de compromisso a ser utilizado para o
                        agendamento da vistoria inicial.
                    </label>
                    <UnForm.LazySelect
                        getDS={(e: any) => e.DS_TIPO_COMPROMISSO}
                        getKeyValue={(e: any) => e.ID_TIPO_COMPROMISSO}
                        controller={ListarTipoAgendamento}
                        name="ID_COMPROMISSO_AGENDAMENTO_VISTORIA_INICIAL"
                        defaultValue={
                            config.ID_COMPROMISSO_AGENDAMENTO_VISTORIA_INICIAL
                        }
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
                <div className="d-flex flex-column col-12 col-md-6">
                    <label className="pt-2">
                        Informe o tipo de compromisso a ser utilizado para o
                        agendamento da execução de serviço.
                    </label>
                    <UnForm.LazySelect
                        getDS={(e: any) => e.DS_TIPO_COMPROMISSO}
                        getKeyValue={(e: any) => e.ID_TIPO_COMPROMISSO}
                        controller={ListarTipoAgendamento}
                        name="ID_COMPROMISSO_AGENDAR_MANUTENCAO"
                        defaultValue={config.ID_COMPROMISSO_AGENDAR_MANUTENCAO}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Tipos de Compromissos
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>

            <div className="col-12 my-4">
                <h4>Agendamentos Previamente Cadastrados</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        O agendamento deverá listar apenas as disponibilidades
                        previamente cadastradas.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS
                                    }
                                    onChange={() => {
                                        config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS =
                                            !config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Preenchimento de nome no Formulário</h4>
                <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        Deseja permitir a seleção apenas dos nomes dos contatos
                        vinculados ao proponente?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_AT
                                    }
                                    onChange={() => {
                                        config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_AT =
                                            !config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_AT;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <UnForm handleSubmit={handleSubmit}>
                <div className="d-flex flex-column col-12 col-md-6">
                    <label className="pt-2">
                        Categoria atendimento{" "}
                        <span className="font-weight-bolder">URA</span>
                    </label>
                    <UnForm.SelectCategoriaAtendimento
                        ID_MODULO={1}
                        defaultValue={findCategoria?.ID_CATEGORIA_ATENDIMENTO}
                        name="ID_CATEGORIA_ATENDIMENTO_URA"
                    />
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Categoria
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>

            <UnForm handleSubmit={handleEmailSubmit}>
                <div className="d-flex flex-column col-12 col-md-6">
                    <h4 className="pt-2">Disparo de email agendamento</h4>
                    <label className="col-12 col-form-label px-0">
                        Selecione o email de disparo para agendamento
                    </label>
                    <UnForm.LazySelect
                        name="ID_REMETENTE"
                        controller={ListarEmailContaController}
                        getDS={(ds) => ds.DS_USERNAME}
                        getKeyValue={(key) => key.DS_USERNAME}
                        defaultValue={config.DS_EMAIL_ENVIO_ASSIS_TECNICA ?? ""}
                        placeholder={"Digite o email"}
                        filter={(u) => u.FL_VALIDADO}
                    >
                        <option value={""}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Email
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>

            <div className="col-12 col-md-6 mb-4 mt-4">
                <h4>Selecionar formulário</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja selecionar um formulário para o atendimento?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config.FL_ESCOLHER_FORMULARIO_ASSISTENCIA
                                    }
                                    onChange={() => {
                                        Config.FL_ESCOLHER_FORMULARIO_ASSISTENCIA =
                                            !Config.FL_ESCOLHER_FORMULARIO_ASSISTENCIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Pesquisa de Satisfação</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja enviar a pesquisa de satisfação de forma manual?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_ENVIO_PESQUISA_MANUAL_ASSIS_TECNICA
                                    }
                                    onChange={() => {
                                        config.FL_ENVIO_PESQUISA_MANUAL_ASSIS_TECNICA =
                                            !config.FL_ENVIO_PESQUISA_MANUAL_ASSIS_TECNICA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja enviar a pesquisa de satisfação via WhatsApp?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_PESQUISA_SATISFACAO_WPP_ASSIS_TEC
                                    }
                                    onChange={() => {
                                        config.FL_PESQUISA_SATISFACAO_WPP_ASSIS_TEC =
                                            !config.FL_PESQUISA_SATISFACAO_WPP_ASSIS_TEC;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {Config.FL_ESCOLHER_FORMULARIO_ASSISTENCIA && (
                <UnForm handleSubmit={handleFormularioSubmit}>
                    <div className="col-12 col-md-6">
                        <UnForm.LazySelect
                            label="Selecione um formulário"
                            name="ID_FORMULARIO"
                            controller={ListarFormulariosController}
                            getDS={(ds) => ds.DS_FORMULARIO}
                            getKeyValue={(key) => key.ID_FORMULARIO}
                            registerOptions={{
                                required: "Selecione um formulário",
                            }}
                            defaultValue={lstFormularioPorModulo?.ID_FORMULARIO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <label></label>
                            <UnForm.SubmitButton
                                color="success"
                                icon={faPaperPlane}
                                loadingSize="sm"
                                loading={VincularFormularioModuloLoading}
                                disabled={VincularFormularioModuloLoading}
                            >
                                Escolher formulário
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            )}
        </OrSpinner>
    );
}
